var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "wl-upload-container", staticClass: "wl-upload flex" },
    [
      _c("el-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "wl-upload-input",
        attrs: { type: "textarea" },
        model: {
          value: _vm.uploadValue,
          callback: function ($$v) {
            _vm.uploadValue = $$v
          },
          expression: "uploadValue",
        },
      }),
      _c("file-full-image", {
        attrs: {
          show: _vm.fullImage,
          defaultImage: _vm.defaultImage,
          files: _vm.files,
          fit: _vm.getOptions.fit,
          options: _vm.getOptions,
        },
        on: {
          "update:show": function ($event) {
            _vm.fullImage = $event
          },
        },
      }),
      _c(
        "el-upload",
        _vm._g(
          _vm._b(
            {
              ref: "wl-upload",
              staticClass: "el-upload-wrapper",
              class:
                ((_obj = {}),
                (_obj[_vm.isList ? " isList" : " noList"] = true),
                (_obj["wl-upload--" + _vm.getOptions["list-type"]] = true),
                _obj),
              staticStyle: { border: "0" },
              attrs: {
                disabled: _vm.$$isDisabled(_vm.$attrs.disabled),
                "before-upload": _vm.beforeUpload,
                "on-change": _vm.onChange,
                "on-progress": _vm.onProgress,
                "on-success": _vm.onSuccess,
                "on-remove": _vm.onRemove,
                "show-file-list": _vm.isList,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "trigger",
                    fn: function () {
                      return [
                        _vm._t("trigger", [
                          _vm.getOptions["list-type"] === "picture-card" ||
                          _vm.getOptions.drag
                            ? [
                                _vm.isList ||
                                (!_vm.isList && _vm.$$isEmpty(_vm.getLastFile))
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "flex-center",
                                        staticStyle: { padding: "5px" },
                                        style:
                                          _vm.getOptions["list-type"] ===
                                          "picture-card"
                                            ? _vm.getImageSize
                                            : {},
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "el-icon-upload",
                                          style: {
                                            "font-size": "3em",
                                            color: "#C0C4CC",
                                            margin: 0,
                                          },
                                        }),
                                        _vm.getOptions.drag
                                          ? _c(
                                              "span",
                                              {
                                                style: {
                                                  "line-height": "1.5em",
                                                  color: "#909399",
                                                },
                                              },
                                              [
                                                _vm._v("将文件拖到此处，或 "),
                                                _c(
                                                  "em",
                                                  {
                                                    staticStyle: {
                                                      color: "#409eff",
                                                    },
                                                  },
                                                  [_vm._v("点击上传")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _c(
                                "el-button",
                                {
                                  style:
                                    "" +
                                    (_vm.$$isNoEmpty(_vm.getLastFile)
                                      ? "margin-right: 5px;"
                                      : ""),
                                  attrs: { size: "small", type: "primary" },
                                },
                                [_vm._v("点击上传")]
                              ),
                          !_vm.isList && _vm.$$isNoEmpty(_vm.getLastFile)
                            ? [
                                _c("file-view", {
                                  attrs: {
                                    file: _vm.getLastFile,
                                    options: _vm.getOptions,
                                    imagesSize: _vm.getImageSize,
                                  },
                                  on: {
                                    "on-remove": _vm.onRemove,
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                    },
                                    "full-image": _vm.fullImageFile,
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "file",
                    fn: function (ref) {
                      var file = ref.file
                      return [
                        _vm._t(
                          "file",
                          [
                            _c("file-view", {
                              attrs: {
                                file: file,
                                options: _vm.getOptions,
                                imagesSize: _vm.getImageSize,
                              },
                              on: {
                                "on-remove": _vm.onRemove,
                                "full-image": _vm.fullImageFile,
                              },
                            }),
                          ],
                          { file: file }
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            },
            "el-upload",
            _vm.getOptions,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm.$attrs.tip || true
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [_vm._v(_vm._s(_vm.$attrs.tip))]
              )
            : _vm._e(),
          _vm._t(
            "default",
            null,
            { fileList: _vm.defaultFiles },
            _vm.getOptions
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }